import { makeObservable } from "mobx";
import { View } from "tamagui";
import type { Api } from "../../../core/apis";
import type { Stores } from "../../../core/stores";
import BaseModuleDataModel, {
  type BaseModuleModelData,
} from "../../core/BaseModuleDataModel";

export interface RatingModelData extends BaseModuleModelData {
  rating: number;
  userId: string;
  dataItemUid: string;
}

export default class RatingModel extends BaseModuleDataModel<RatingModelData> {
  constructor(stores: Stores, api: Api, data: RatingModelData) {
    super(stores, api, data);

    makeObservable(this);
  }

  setRating(rating: number) {
    this.data.rating = rating;

    // TODO - post activity event?
    this.sendTelemetryEvent("rating_set");

    return this.api.modulesDataApi.set(this);
  }

  toFireStore(): Omit<RatingModelData, "uid"> {
    return {
      ...this.fromBaseModel(),
      ...super.toFireStore(),
      ...this.data,
    };
  }

  render() {
    return <View />;
  }

  static is(
    module: BaseModuleDataModel<BaseModuleModelData>,
  ): module is RatingModel {
    return module instanceof RatingModel;
  }
}
